import { useParams } from 'react-router-dom';
import { SettingsPage } from './PreferencesPage';

/**
 * Renders the notification settings page within the Access Management product
 * area, with breadcrumbs appropriate for that context.
 *
 * Reads :entityId and :userId from the URL to build the "My Profile" back link.
 * Registered in the route registry at NOTIFICATIONS_SETTINGS_PATH_PATTERN.
 */
export function NotificationsSettingsAccessManagementPage() {
  const { entityId, userId } = useParams<{ entityId: string; userId: string }>();
  return (
    <SettingsPage
      breadcrumbs={[
        { title: 'My Profile', path: `/access/${entityId}/users/${userId}` },
        {
          title: 'Notification Settings',
          path: `/access/${entityId}/users/${userId}/notifications-settings`,
        },
      ]}
    />
  );
}
